import React, { useEffect, useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import { Box, Button, Grid, InputLabel, MenuItem, Pagination, Select } from '@mui/material';
import { useMain } from '../hooks/useMain';
import ShowLoader from 'src/components/CustomComponents/ShowLoader';
import SearchImg from '../../assets/search.svg';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import FieldData from './FieldData';

const searchMenu = [
  { searchKey: 'branchEmail', label: 'Email' },
  { searchKey: 'branchName', label: 'Name' },
];

const searchInputPlaceholder = {
    branchEmail: 'example@example.com',
    branchName: 'name',

};

const AllRequests = () => {

  const [showLoader, setShowLoader] = useState(true);
  const [data, setData] = useState([]);
  const [checkedRequests,setCheckedRequests]=useState([]);
  const [searchKey, setSearchKey] = useState('branchEmail');
  const [searchValue, setSearchValue] = useState('');
  const [sortBy, setSortBy] = useState('createdAt');
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);

  const { fetchAllRequest } = useMain();

  const clearDataHandler = () => {
    setData([]);
    setSearchKey('branchEmail');
    setSearchValue('');
    getData('clear');
  };

  const onApplyHandler = () => {
    getData();
  };

  const handleSearchKey=(e)=>{
    setSearchKey(e.target.value)
    setSearchValue('')
  }

  const handleFilter = (e) => {
    setSortBy(e.target.value);
  };

  const getData = async (key) => {
    let queryParams = `?page=${page}&limit=${limit}&sortBy=${sortBy}${
      searchValue ? `&searchKey=${searchKey}&searchValue=${searchValue}` : ''
    }`;
    if (key) queryParams = `?page=${page}&limit=${limit}&sortBy=createdAt`;
    try {
      setShowLoader(true);
      const res = await fetchAllRequest(queryParams);
      if(res.statusCode === 200){ 
       const filteData= res?.data?.filter((item) => item?.activeStatus === 'PENDING')
        setData(filteData||[]);
      }
      else{

      }
    } catch (error) {

    }finally{
      setShowLoader(false);
    }
   
  };

  useEffect(() => {
    getData();
    return () => {
      setData([])
    };
  }, [limit,page,sortBy]);

  
  const handleLimitChange = (e) => {
    setLimit(e.target.value);
    setPage(1)
  };


  return (
    <PageContainer title="All Requests" description="this contains all Requests">
      <DashboardCard2 title="All Requests">
      <Grid container spacing={2} alignItems="center">
          <Grid item xs={6}>
          <Box>
              <InputLabel>Show per page</InputLabel>
              <Select
                style={{
                  borderRadius: '7px',
                  border: '0.5px solid #6174DD',
                  padding: '4px 12px',
                  background: '#FFF',
                  height: '40px',
                  // width:'100px'
                }}
                value={limit}
                onChange={handleLimitChange}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
            </Box>
          </Grid>
          <Grid item xs={6} container justifyContent="flex-end">
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '10px',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  margin: '0px 5px 0px 10px',
                  minWidth: '56px',
                }}
              >
                <span>Sort By : </span>
              </div>
              <div>
                <Box>
                  <Select
                    style={{
                      borderRadius: '7px',
                      border: '0.5px solid #6174DD',
                      padding: '4px 12px',
                      background: '#FFF',
                      height: '40px',
                    }}
                    value={sortBy}
                    onChange={handleFilter}
                  >
                    <MenuItem value="createdAt">Newest</MenuItem>
                  </Select>
                </Box>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  margin: '0px 5px 0px 10px',
                  minWidth: '74px',
                }}
              >
                <span>Search By : </span>
              </div>
              <div>
                <Box>
                  <Select
                    style={{
                      borderRadius: '7px',
                      border: '0.5px solid #6174DD',
                      padding: '4px 12px',
                      background: '#FFF',
                      height: '40px',
                      minWidth: '190px',
                    }}
                    value={searchKey}
                    onChange={handleSearchKey}
                  >
                    {searchMenu.map((item, index) => (
                      <MenuItem key={index} value={item.searchKey}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </div>
              <div className="search-input">
                <img src={SearchImg} alt="" />
                <input
                  type="text"
                  placeholder={searchInputPlaceholder[searchKey]}
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.target.value)}
                />
              </div>
              <div>
                <Button
                  disabled={searchValue ? false : true}
                  variant="contained"
                  color="primary"
                  target="_blank"
                  sx={{
                    background: '#6174DD',
                  }}
                  onClick={onApplyHandler}
                >
                  Apply
                </Button>
              </div>
              <div>
                <Button
                  disabled={searchValue ? false : true}
                  variant="contained"
                  color="primary"
                  target="_blank"
                  sx={{
                    background: '#ff4d4d',
                    '&:hover': {
                      background: '#ff6666',
                    },
                  }}
                  onClick={clearDataHandler}
                >
                  Clear
                </Button>
              </div>
            </div>
          </Grid>
        </Grid>
        {showLoader?<ShowLoader />:data.length > 0?<><Box>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
            <FieldData data={data} setData={setData} getData={getData} checkedRequests={checkedRequests} setCheckedRequests={setCheckedRequests}/>
            </Grid>
          </Grid>
        </Box>
          <Box display={'flex'} justifyContent={'flex-end'}>
            <Pagination
              count={data.length < limit ? page : page + 1}
              page={page}
              color="primary"
              onChange={(e, page) => setPage(page)}
            />
          </Box></>:<div
            style={{
              width: '100%',
              textAlign: 'center',
              color: 'red',
              fontWeight: 'bold',
              fontSize: '18px',
            }}
          >
            No Data Found
          </div>
        }
      </DashboardCard2>
    </PageContainer>
  );
};

export default AllRequests;